import React from 'react';
import { Image } from 'react-native';
import { create } from '../display-names';
const ItemImage = create(_ref => {
  let {
    source,
    style,
    height,
    width,
    fadeDuration = 0,
    resizeMode,
    accessibilityLabel
  } = _ref;
  return /*#__PURE__*/React.createElement(Image, {
    resizeMode: resizeMode,
    fadeDuration: fadeDuration,
    style: style,
    source: source,
    width: width,
    height: height,
    accessibilityLabel: accessibilityLabel
  });
}, 'ItemImage');
export { ItemImage };
//# sourceMappingURL=item-image.js.map